module.exports = __webpack_public_path__ + "assets/logo_footer.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer.png
 ** module id = 141
 ** module chunks = 1
 **/